import { dateFormatter, formatDateToOnlyMonthAndYear } from '../../helpers/utils'
import { UserEducationalHistoryDTO, UserWorkHistoryDTO } from '../../models/users'

const getEndDate = (endDate: Date) => {
    return endDate ? formatDateToOnlyMonthAndYear(dateFormatter(new Date(endDate))) : 'Actualidad'
}

interface ProfessionalProps {
    info: UserWorkHistoryDTO
}
export const UserProfessionalExperienceCard = ({ info }: ProfessionalProps) => {
    return (
        <div className="flex gap-2 md:gap-4 items-center h-[90px] md:h-[110px]">
            <div className="bg-success w-[3px] md:w-[5px] h-full" />
            <div className="flex justify-center gap-5 md:gap-20 w-full max-h-[90px] md:max-h-[110px]">
                <div className="flex flex-col w-[50%]">
                    <span className="line-clamp-1 text-xs md:text-lg">{info.jobTitle}</span>
                    <span className="line-clamp-1 text-xs md:text-lg mb-2 md:mb-3">
                        {info.employerName}
                    </span>
                    <span className="line-clamp-1 text-xs md:text-base">
                        {`${formatDateToOnlyMonthAndYear(dateFormatter(new Date(info.startDate)))} - ${getEndDate(info.endDate)}`}
                    </span>
                    <span className="text-xs md:text-base">{info.employerCountry}</span>
                </div>
                <div className="flex flex-col overflow-auto w-[50%]">
                    <span className="text-xs md:text-lg md:mb-3">Responsabilidades:</span>
                    <span className="text-xs md:text-base">{info.description}</span>
                </div>
            </div>
        </div>
    )
}

interface EducationalProps {
    info: UserEducationalHistoryDTO
}
export const UserEducationalExperienceCard = ({ info }: EducationalProps) => {
    return (
        <div className="flex gap-2 md:gap-4 items-center h-[90px] md:h-[110px]">
            <div className="bg-alert w-[3px] md:w-[5px] h-full" />
            <div className="flex justify-center gap-5 md:gap-20 w-full max-h-[90px] md:max-h-[110px]">
                <div className="flex flex-col h-full w-[50%]">
                    <span
                        title={info.areaOfStudy}
                        className="text-xs md:text-lg mb-2 md:mb-3 line-clamp-2"
                    >
                        {info.areaOfStudy}
                    </span>
                    <span className="line-clamp-1 text-xs md:text-base">
                        {`${formatDateToOnlyMonthAndYear(dateFormatter(new Date(info.startDate)))} - ${getEndDate(info.endDate)}`}
                    </span>
                    <span className="line-clamp-1 text-xs md:text-base">{info.degree}</span>
                </div>
                <div className="flex flex-col w-[50%]">
                    <span
                        title={info.school}
                        className="text-xs md:text-lg mb-2 md:mb-3 line-clamp-2"
                    >
                        {info.school}
                    </span>
                    <span className="text-xs md:text-base">{info.country}</span>
                </div>
            </div>
        </div>
    )
}
